<ion-button
  fill="outline"
  (click)="showUploadFreightFileModal()"
>
  <ion-icon
    aria-hidden="true"
    slot="start"
    src="../assets/material-symbols/person_add_24dp_FILL0_wght400_GRAD0_opsz24.svg"
  ></ion-icon>
  Subir archivo de cargas
</ion-button>
